(function() {
    'use strict';
    
    const $body = document.body;
    
    const formMessage = {
        resetForm: function (form) {
            const formEl = form instanceof Element ? form : (form && form[0] ? form[0] : form);
            if (!formEl) return;
            
            formEl.querySelectorAll('.form-field').forEach(field => {
                field.classList.remove('form-field--success', 'form-field--error');
            });
            formEl.querySelectorAll('input[type=email], input[type=text], textarea').forEach(input => {
                input.value = '';
            });
        },

        formMessage: function () {
            // Helper function to get cookie
            const getCookie = (name) => {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
                return null;
            };
            
            // Helper function to set cookie
            const setCookie = (name, value, days, path = '/') => {
                const expires = new Date();
                expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
                document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=${path}`;
            };
            
            const error = window.location.href.indexOf('form_type=contact') > -1;

            if (window.location.href.indexOf('contact_posted=true') > -1 || error) {
                const contactFormCookie = getCookie('contact_form');
                const formMessageEl = contactFormCookie ? document.querySelector(`[data-form-message="${contactFormCookie}"]`) : null;
                if (!formMessageEl) return;
                
                let delay = 400;

                if ($body.classList.contains('template-product')) delay = 1600;

                const formMessageType = formMessageEl.dataset.formMessage;
                switch (formMessageType) {
                    case 'ask':
                        setTimeout(() => { $body.classList.add('ask-an-expert-show') }, delay);
                        formMessage.changeStateforContactForm(formMessageEl, error);
                        document.querySelectorAll('.halo-notify-popup .form-message').forEach(el => {
                            el.classList.add('hidden');
                        });
                        break;
                    case 'contact':
                        formMessageEl.classList.remove('hidden');
                        formMessage.changeStateforContactForm(formMessageEl, error);
                        document.querySelectorAll('.halo-notify-popup .form-message').forEach(el => {
                            el.classList.add('hidden');
                        });
                        break;
                    case 'notifyMe':
                        document.querySelectorAll('.halo-notify-popup .form-field').forEach(el => {
                            el.classList.add('hidden');
                        });
                        setTimeout(() => { $body.classList.add('notify-me-show') }, delay);
                        formMessage.changeStateforContactForm(formMessageEl, error);
                        break;
                }
            }

            document.addEventListener('click', (event) => {
                const button = event.target.closest('[data-button-message]');
                if (button) {
                    const message = button.dataset.buttonMessage;
                    if (message) {
                        setCookie('contact_form', message, 1, '/');
                    }
                }
            });
        },

        changeStateforContactForm: function(formMessage, error) {
            window.history.pushState('object', document.title, location.href.split('?')[0]);
            if (error) {
                document.querySelectorAll('.newsletter-form__message--error').forEach(el => {
                    el.classList.add('hidden');
                });
                if (formMessage) {
                    const formMessageEl = formMessage instanceof Element ? formMessage : (formMessage && formMessage[0] ? formMessage[0] : formMessage);
                    if (formMessageEl) {
                        const rect = formMessageEl.getBoundingClientRect();
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        const targetY = rect.top + scrollTop - (window.innerHeight / 2);
                        window.scrollTo({
                            top: targetY,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        }
    };
    
    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }
    
    // Attach all form message functions to halo
    Object.assign(window.halo, formMessage);
    
    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            formMessage.formMessage();
        });
    } else {
        formMessage.formMessage();
    }
})();









